<script lang="ts">
  import SectionTransactionSalarie from '@/generated/sections/SectionTransactionSalarie.vue';
  import { defineComponent } from "vue";
  import { ColumnFilter, ListChoix } from '@/extend/classes/ListData';
  import { TransactionTypes } from '@/generated/classes/Transaction';
  import { ObjTypes } from '@/generated/classes/ObjTypes';
  import { getCurrency } from '@/framework/base/helpers/Localization';

  export default defineComponent({
    components: {},
    extends: SectionTransactionSalarie,

    computed: {
      headers () {
        return [
          { text: "Destinataire", value: 'ownerLabel', cellClass: '', sortable: true },
          { text: "Contrat", value: 'info', cellClass: '', sortable: true },
          { text: "Montant", value: 'amount', cellClass: '', sortable: true },
          { text: "Date d'émission", value: 'dateProcess', cellClass: '', sortable: true },
          { text: "Référence", value: 'reference', cellClass: '', sortable: true }
        ];
      },
      canAdd (): boolean {
        return false;
      }
    },
    methods: {
      defaultFilter (): void {
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "info";
          columnFilter.staticFilter = true;
          columnFilter.sortDescending = true;
          this.activeFilters.push(columnFilter);
        }
          {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "type";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = TransactionTypes.VIREMENT_EMIS;
          columnFilter.filters.push(choix);
        }
        {
          const columnFilter = new ColumnFilter();
          columnFilter.name = "ownerType";
          columnFilter.staticFilter = true;
          const choix = new ListChoix();
          choix.value = ObjTypes.SALARIE;
          columnFilter.filters.push(choix);
          this.activeFilters.push(columnFilter);
        }
      },
      selectItem (event: any, row: any): void {
      },
      getLabel (name: string, item: number, obj: unknown): string {
        const transaction = obj as Transaction;
        let res = item == 0 || item == null ? '' : item.toString();
        if (name == 'amount') {
          res = getCurrency(item);
        } else if (name == "dateProcess" && item) {
          res = new Date(transaction.dateProcess).toString();
        }

        return res;
      },

    }
  })
</script>
